<template>
  <layout>
    <template v-slot:header>
      <div class="admin-header-container align-items-start align-items-lg-center mb-2 mb-lg-0">
        <h2 class="m-0">Manufacturers</h2>
        <jet-button class="btn-short ml-0 ml-lg-2" :goesTo="route('manufacturers.create')" icon="fas fa-tools">Create Manufacturer</jet-button>
      </div>
      <BreadCrumbs activeItem="Manufacturers" :crumbs="{ home: 'Dashboard'}"/>
      <flash-messages />
      <AppHead title="Manage Manufacturers" />
    </template>
            
    <template v-slot:default>
      <div class="row mb-4">
        <div class="col-12 col-lg-4 mb-3 mb-lg-0">
          <card title="Reorder Manufacturers" headerStyle="dark">
            <p class="mb-2 text-size-small text-primary">
              <i class="fas fa-hand-pointer mr-2"></i>Drag Items to Reorder Manufacturers
            </p>
            <draggable :list="$page.props.manufacturers_sort" item-key="id" class="list-group" :delay="50" @change="changed">
              <template #item="{element}">
                <li class="list-group-item list-group-item-info py-1 cursor-pointer">
                  <strong v-if="element.sort_order >= 0">{{element.sort_order+1}} - </strong>{{element.name}}({{element.short_name}})
                </li> 
              </template>
            </draggable>
          </card>
        </div>

        <div class="col-12 col-lg-8 table-responsive">
          <table class="table table-striped table-sm tbody-border">
            <thead>
              <tr>
                <th>Name</th>
                <th>Code</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="manufacturer in manufacturers" :key="manufacturer.id">
                <td>
                  <inertia-link class="px-6 py-4 m-text-nowrap flex items-center focus:text-indigo-500" :href="route('manufacturers.edit', manufacturer.id)">
                    {{ manufacturer.name }}
                  </inertia-link>
                </td>
                <td>
                  <inertia-link class="px-6 py-4 flex items-center" :href="route('manufacturers.edit', manufacturer.id)" tabindex="-1">
                    {{ manufacturer.short_name }}
                  </inertia-link>
                </td>
                <td class="d-flex justify-content-end pr-5">
                  <jet-button class="btn-short mr-2 text-nowrap" :goesTo="route('manufacturers.view', manufacturer.id)" icon="fas fa-chevron-right">View</jet-button>
                  <jet-button class="btn-short mr-2 text-nowrap" :goesTo="route('manufacturers.edit', manufacturer.id)" icon="fas fa-pencil-alt">Edit</jet-button>
                  <jet-button class="btn-short text-nowrap" btnStyle="danger" @click="$inertia.visit(route('manufacturers.destroy', manufacturer.id))" icon="nav-icon fas fa-trash">Remove</jet-button>
                </td>
              </tr>
            </tbody>
            <tr v-if="manufacturers.length === 0">
              <td class="border-t px-6 py-4" colspan="4">No manufacturers.</td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </layout>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Admin/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import FlashMessages from '@/Shared/FlashMessages'
import draggable from 'vuedraggable'
import BreadCrumbs from '@/Shared/BreadCrumbs'

export default {
  components: {
    Icon,
    SearchFilter,
    Layout,
    FlashMessages,
    draggable,
    BreadCrumbs
  },
  props: {
    manufacturers: Array,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('manufacturers', Object.keys(query).length ? query : { remember: 'forget' }))
      }, 150),
      deep: true,
    },
  },
  mounted() {
    this.sortManufacturers()
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    sortManufacturers() {
      this.$page.props.manufacturers_sort.forEach( (elem, index) => { elem.sort_order = index })
    },
    changed() {
      this.sortManufacturers()
      this.$inertia.post(route('manufacturers.saveorder'), {
        manufacturers:JSON.stringify(this.$page.props.manufacturers_sort),
        }, { preserveScroll: true })
    }
  },
}
</script>
